export default (key = 'modal-state') => {
  const state = useState<{ isOpen: boolean }>(key, () => ({
    isOpen: false,
  }))

  const toggle = (isOpen: boolean) => {
    state.value.isOpen = isOpen
  }

  const isOpen = computed(() => state.value.isOpen)

  return {
    isOpen,
    toggle,
  }
}
